import { notifyOrganizerWrite } from "./organizerUpdates";
import { withApiKeyHeaders } from "./apiKeyFetch";
import { logoutAndRedirect, notifyAuthUpdated } from "./authSession";

let refreshInFlight = null;

function getAuthPayload() {
  const raw = localStorage.getItem("authPayload");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    console.error("Invalid authPayload in localStorage:", e);
    localStorage.removeItem("authPayload");
    return null;
  }
}

function setAuthPayload(payload) {
  localStorage.setItem("authPayload", JSON.stringify(payload));
}

async function refreshIdToken() {
  const payload = getAuthPayload();
  const refresh_token = payload?.refresh_token;
  if (!refresh_token) return null;

  if (!refreshInFlight) {
    refreshInFlight = (async () => {
      const headers = withApiKeyHeaders(
        `${process.env.REACT_APP_API_BASE}/refresh`,
        {
          "Content-Type": "application/json",
        }
      );

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/refresh`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({ refresh_token }),
        }
      );

      if (!response.ok) {
        return null;
      }

  const data = await response.json();
  const nextPayload = {
    ...payload,
    id_token: data.id_token,
    refresh_token: data.refresh_token || payload.refresh_token,
  };
  setAuthPayload(nextPayload);
  notifyAuthUpdated();

  return data.id_token;
    })().finally(() => {
      refreshInFlight = null;
    });
  }

  return refreshInFlight;
}

export async function fetchWithAuth(url, options = {}) {
  const payload = getAuthPayload();
  const id_token = payload?.id_token;

  const headers = withApiKeyHeaders(url, {
    ...(options.headers || {}),
  });

  const isFormData =
    typeof FormData !== "undefined" && options.body instanceof FormData;

  if (isFormData) {
    headers.delete("Content-Type");
  } else if (!headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  if (id_token && !headers.has("FirebaseToken")) {
    headers.set("FirebaseToken", id_token);
  }

  try {
    const response = await fetch(url, { ...options, headers });

    if (response.status === 401) {
      const newToken = await refreshIdToken();
      if (newToken) {
        const retryHeaders = withApiKeyHeaders(url, {
          ...(options.headers || {}),
        });

        if (isFormData) {
          retryHeaders.delete("Content-Type");
        } else if (!retryHeaders.has("Content-Type")) {
          retryHeaders.set("Content-Type", "application/json");
        }

        retryHeaders.set("FirebaseToken", newToken);
        const retried = await fetch(url, { ...options, headers: retryHeaders });
        notifyOrganizerWrite(url, options.method, retried);
        return retried;
      }

      console.warn("Token expired or invalid. Logging out...");
      logoutAndRedirect("/login");
      return;
    }

    notifyOrganizerWrite(url, options.method, response);
    return response;
  } catch (err) {
    console.error("Fetch error:", err);
    throw err;
  }
}
